import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  OrganizationItemCreate,
  OrganizationItemDelete,
  OrganizationItemInitialState,
  OrganizationItemLoad,
  OrganizationItemUpdate,
} from './organization-item.actions';
import { OrganizationItemState, OrganizationItemStateModel } from './organization-item.state';
import { OrganizationItemModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class OrganizationItemFacade implements LoadDataFacade, SetInitialStateFacade {
  organizationData$: Observable<OrganizationItemStateModel> = this.store.select(OrganizationItemState.getState);
  organizationId$: Observable<number> = this.store.select(OrganizationItemState.getOrganizationId);
  organizationName$: Observable<string> = this.store.select(OrganizationItemState.getOrganizationName);
  loaded$: Observable<boolean> = this.store.select(OrganizationItemState.getLoaded);

  constructor(private store: Store) {}

  loadAll(organizationId: string): void {
    this.store.dispatch(new OrganizationItemLoad(organizationId));
  }

  createOrganization(data: OrganizationItemModel): void {
    this.store.dispatch(new OrganizationItemCreate(data));
  }

  updateOrganization(data: OrganizationItemModel): void {
    this.store.dispatch(new OrganizationItemUpdate(data));
  }

  deleteOrganization(organizationId: string, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new OrganizationItemDelete({ dialog, organizationId }));
  }

  setInitialState(): void {
    this.store.dispatch(new OrganizationItemInitialState());
  }
}
